module.exports = __webpack_public_path__ + "static/media/uba-logo.00077a54.png";